import { Provider } from '@angular/core'
import { environment } from '../../environments/environment'
import { identityConfigToken } from 'shared-components'
import { IdentityConfig } from 'identity-services'

const identityConfig: IdentityConfig = {
  apiBaseUrl: environment.identityApiBaseUrl,
  minPasswordLength: 8,
}

export const playIdentityConfigsProvider: Provider = {
  provide: identityConfigToken,
  useValue: identityConfig,
}
